var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { convertToDate, E_DATE_TYPE } from 'src/shared/helpers/dateHelpers';
import { ZERO_WIDTH_SPACE } from 'src/shared/constants';
import styles from './ComparisonItem.module.scss';
export var isComparisonFieldGuard = function (obj) {
    return obj && obj.label !== undefined;
};
export var ComparisonItem = function (props) {
    var i18n = props.i18n, description = props.description, previousIdentity = props.previousIdentity, nextIdentity = props.nextIdentity, fields = props.fields;
    var valueClass = function (isDifferent) {
        return classNames(styles.acceptedItemInputValue, isDifferent ? styles.acceptedItemInputValueDifferent : styles.acceptedItemInputValueNotDifferent);
    };
    var previousWrapperLabel = getPropsByKeyPath(i18n.keyValueMap, "history.previousLabel");
    var nextWrapperLabel = getPropsByKeyPath(i18n.keyValueMap, "history.nextLabel");
    var visibleFields = fields.map(function (field) {
        var isComparisonField = isComparisonFieldGuard(field);
        var previousValue = isComparisonField
            ? getPropsByKeyPath(previousIdentity, field.key)
            : getPropsByKeyPath(previousIdentity, field);
        var nextValue = isComparisonField ? getPropsByKeyPath(nextIdentity, field.key) : getPropsByKeyPath(nextIdentity, field);
        var isToProcessAsArray = Array.isArray(previousValue) || Array.isArray(nextValue);
        var maxLength = isToProcessAsArray ? Math.max((previousValue === null || previousValue === void 0 ? void 0 : previousValue.length) || 0, (nextValue === null || nextValue === void 0 ? void 0 : nextValue.length) || 0) : 0;
        var fillArrayWithSpace = function (array, length) {
            return Array.from({ length: length }, function (_, index) { return (array && array[index]) || ZERO_WIDTH_SPACE; });
        };
        var label = isComparisonField
            ? field.label
            : isToProcessAsArray
                ? Array.from({ length: maxLength }, function (_, index) { return getPropsByKeyPath(i18n.keyValueMap, "history.comparison.labels.".concat(field).concat(index)); })
                : getPropsByKeyPath(i18n.keyValueMap, "history.comparison.labels.".concat(field));
        var previousValueProcessed = isToProcessAsArray ? fillArrayWithSpace(previousValue, maxLength) : previousValue;
        var nextValueProcessed = isToProcessAsArray ? fillArrayWithSpace(nextValue, maxLength) : nextValue;
        var isDifferent = isToProcessAsArray ? previousValueProcessed.map(function (value, index) { return value !== nextValueProcessed[index]; }) : previousValue !== nextValue;
        return {
            previousValue: previousValueProcessed,
            nextValue: nextValueProcessed,
            isPresent: !!previousValue || !!nextValue,
            isDifferent: isDifferent,
            label: label,
            isDate: isComparisonField ? field.key.toLowerCase().indexOf('date') >= 0 : field.toLowerCase().indexOf('date') >= 0,
            isArray: isToProcessAsArray
        };
    });
    return (_jsxs("div", __assign({ className: styles.acceptedItemWrapper }, { children: [description, _jsxs("div", __assign({ className: styles.acceptedInputsWrapper }, { children: [_jsx("div", __assign({ className: styles.acceptedInputLabelsWrapper }, { children: visibleFields.map(function (field) {
                            if (field.isPresent) {
                                return field.isArray ? field.label.map(function (label) { return _jsx("span", { children: label }); }) : _jsx("span", { children: field.label });
                            }
                        }) })), _jsxs("div", __assign({ className: styles.acceptedInputWrapper }, { children: [_jsx("p", { children: previousWrapperLabel }), _jsx("div", __assign({ className: styles.acceptedItemInputs }, { children: visibleFields.map(function (field) {
                                    if (field.isPresent) {
                                        return field.isArray
                                            ? field.previousValue.map(function (value, index) {
                                                return (_jsx("p", __assign({ className: styles.acceptedItemInputValue }, { children: value }), "".concat(field.label, "-").concat(index)));
                                            })
                                            : _jsx("p", __assign({ className: styles.acceptedItemInputValue }, { children: field.previousValue
                                                    ? field.isDate
                                                        ? convertToDate(E_DATE_TYPE.DATE, field.previousValue)
                                                        : field.previousValue
                                                    : ZERO_WIDTH_SPACE }), field.label);
                                    }
                                }) }))] })), _jsxs("div", __assign({ className: styles.acceptedInputWrapper }, { children: [_jsx("p", { children: nextWrapperLabel }), _jsx("div", __assign({ className: styles.acceptedItemReviewed }, { children: visibleFields.map(function (field) {
                                    if (field.isPresent) {
                                        return field.isArray
                                            ? field.nextValue.map(function (value, index) {
                                                return (_jsx("p", __assign({ className: valueClass(field.isDifferent[index]) }, { children: value }), "".concat(field.label, "-").concat(index)));
                                            })
                                            : _jsx("p", __assign({ className: valueClass(field.isDifferent) }, { children: field.nextValue
                                                    ? field.isDate
                                                        ? convertToDate(E_DATE_TYPE.DATE, field.nextValue)
                                                        : field.nextValue
                                                    : ZERO_WIDTH_SPACE }), field.label);
                                    }
                                }) }))] }))] }))] })));
};
